//
// For use with show more/show less lists
//
// ---------------------------------------------------------------------------
'use strict';

import translator from '../translator';

const config = {
    clickEvent: 'click touch',
    target: '.js-show-more-link',
    selector: '.js-show-more-list',
    hiddenClass: 'is-hidden',
    expandedClass: 'expanded',
    i18n: {}
};

export default class ShowMore {

    /**
     * Initalize the list
     *
     * @param {jQuery} selector
     */
    constructor(selector) {
        this.collapseList(selector);
        this.setupClickEvents(selector);
    }

    /**
     * Renders the list and cuts off the max number of items before we add a show more link
     *
     * @param {jQuery} list
     */
    collapseList(list) {
        let maxItems = $(list).data('default-visible');
        let moreItems = $(list).find('li').filter(':gt(' + (maxItems - 1) + ')');

        moreItems = moreItems.filter(function() {
            return !$(this).find('input[type=checkbox]').is(':checked');
        });

        moreItems.addClass(config.hiddenClass);

        if (moreItems.length) {
            let link = $(list).find(config.target);

            link.removeClass(config.hiddenClass);
        }
    }

    /**
     * Sets up all click events for this component
     * Also make sure we get translations if there is a visible link
     *
     *  @param {jQuery} list
     */
    setupClickEvents(list) {
        let link = $(list).find(config.target);

        if (link.hasClass(config.hiddenClass)) {
            return;
        }

        this.getTranslations();
        link.on(config.clickEvent, (e) => this.toggleList(e));
    }

    /**
     * Either expands or collapses the list items in the list.
     * Also replaces the text for the show more link
     *
     * @param {event} e
     */
    toggleList(e) {
        e.preventDefault();

        let link = $(e.currentTarget);
        let parentUl = link.parents(config.selector);

        if (link.hasClass(config.expandedClass)) {
            link.text(link.text().replace(
                this.getShowLessText(parentUl.data('list-header')),
                this.getShowMoreText(parentUl.data('list-header'))
            ));
            link.removeClass(config.expandedClass);
            this.collapseList(parentUl);
        } else {
            link.text(link.text().replace(
                this.getShowMoreText(parentUl.data('list-header')),
                this.getShowLessText(parentUl.data('list-header'))
            ));
            link.addClass(config.expandedClass);
            this.expandList(parentUl);
        }
    }

    /**
     * Gets the translations for the show more/show less links
     */
    getTranslations() {
        let showMoreLessTranslationList = translator.getTranslationByKey('searchfilter', 'lists');

        showMoreLessTranslationList.forEach(function (item) {
            let heading = item['heading'];

            config.i18n[heading] = {};
            config.i18n[heading]['showMoreText'] = item['see_more'];
            config.i18n[heading]['showLessText'] = item['see_less'];
        });
    }

    /**
     * Gets the translation for the showMoreText
     *
     * @param {string} header
     * @returns {string/null}
     */
    getShowMoreText(header) {
        if (!config.i18n[header]) {
            return null;
        }

        return config.i18n[header]['showMoreText'];
    }

    /**
     * Gets the translation for the showLessText
     *
     * @param {string} header
     * @returns {string/null}
     */
    getShowLessText(header) {
        if (!config.i18n[header]) {
            return null;
        }

        return config.i18n[header]['showLessText'];
    }

    /**
     * Expands the list
     *
     * @param {jQuery} list
     */
    expandList(list) {
        list.find('li').removeClass(config.hiddenClass);
    }
}

/**
 * Loop over each list and attach the object to this.
 */
$(config.selector).each(function() {
    new ShowMore($(this));
});



// WEBPACK FOOTER //
// ./src/js/components/show-more.js